(ns dashboard.components.file-diff
  (:require [dashboard.entity.document.diff :as diff]
            [dashboard.ui :as ui]
            [re-frame.core :as rf]
            [reagent.core :as r]))

;; ----------------------------------------------------------------------------

(defn file-diff [{{:keys [url filename org-members]} :ctx}]
  (when (.endsWith filename ".pdf")
    [:f> diff/document-compare filename url org-members]))

(rf/reg-event-fx
 ::show-file-diff
 (fn [{:keys [db]} [_ download-url filename id {:keys [url]}]]
   (let [can-close (r/atom true)
         on-prevent-close (fn [value]
                            (reset! can-close value))
         on-close (fn [] (when @can-close (rf/dispatch [::ui/pop-modal])))]
     {:dispatch [::ui/push-modal
                 {:ctx {:url url
                        :filename filename
                        :document-id id
                        :download-url download-url
                        :org-members (get-in db [:organization :data])
                        :on-prevent-close on-prevent-close}
                  :component file-diff
                  :keybinding-overrides {"Escape" on-close}
                  :content-props {:style {:width "98vw"
                                          :padding 0}
                                  :class [:document-viewer--modal]}}]})))
